<template>
    <div
        tabindex="0"
        role="button"
        class="group relative rounded-xl border bg-theme-card p-3 cursor-pointer transition-all duration-200"
        :class="
            isExpanded
                ? 'border-theme-primary shadow-lg sm:col-span-2'
                : 'border-theme-border hover:-translate-y-1 hover:shadow-lg'
        "
        @click="onClick"
        @auxclick.prevent="onAuxClick"
        @keydown.enter="onClick"
    >
        <button
            type="button"
            class="absolute top-2 right-2 flex h-7 w-7 items-center justify-center rounded-full text-lg leading-none hover:bg-theme-hover"
            :class="isFavorite ? 'text-theme-primary' : 'text-theme-muted'"
            :aria-label="
                isFavorite ? 'Quitar de favoritos' : 'Marcar como favorito'
            "
            @click.stop="onToggleFavorite"
        >
            {{ isFavorite ? "★" : "☆" }}
        </button>

        <div class="flex items-center gap-3 pr-8">
            <div
                class="flex flex-shrink-0 h-10 w-10 items-center justify-center rounded-lg bg-brand-blue text-xl text-white leading-none"
            >
                <span
                    class="block leading-none"
                    style="transform: translateY(-2px)"
                >
                    {{ link.icon }}
                </span>
            </div>

            <h3 class="text-sm font-medium text-theme-base">
                {{ link.name }}
            </h3>
        </div>

        <div v-if="isExpanded" class="mt-3 space-y-2">
            <p class="text-sm text-theme-muted">
                {{ link.description }}
            </p>
            <p class="text-xs font-medium text-theme-primary">
                Toca de nuevo para ir →
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolCard",
    props: {
        link: { type: Object, required: true },
        isFavorite: { type: Boolean, default: false },
        isExpanded: { type: Boolean, default: false },
        expandable: { type: Boolean, default: true }
    },
    emits: ["expand", "click", "middle-click", "toggle-favorite"],
    methods: {
        onClick() {
            if (!this.expandable || this.isExpanded) {
                this.$emit("click", this.link);
                return;
            }
            this.$emit("expand", this.link);
        },
        onAuxClick() {
            this.$emit("middle-click", this.link);
        },
        onToggleFavorite() {
            this.$emit("toggle-favorite", this.link);
        }
    }
};
</script>
